import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'intrasense-error-all',
  templateUrl: './error-all.component.html',
  styleUrls: ['./error-all.component.scss']
})
export class ErrorAllComponent implements OnInit {
  @Input() title: string | number = "Error!";
  @Input() description: string = "We're sorry, <br/> The page you were looking for doesn't exist anymore";
  @Output('navigateEvent') action: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private dialogRef: MatDialog,
  ) { }

  ngOnInit(): void {
    this.dialogRef.closeAll();
  }

  navigateTo() {
    this.action.emit(true);
  }
}
